import { messaging } from "../firebase.js";
import { getToken } from "firebase/messaging";

export const requestWebPushPermission = async () => {
  if (!messaging) return null;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  const token = await getToken(messaging, {
    vapidKey: "BKWP8f_VwtY0c-3h2Qdn6zbAt58i-fqMpFOTtVR3K6DIdLdFwhaCCB-Oj1fPxbFBrBwy512AeZ2dbqRxdfnBmHY"
  });

  return token;
};
